var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2225_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.05C14.9902 19.05 19.05 14.9902 19.05 10C19.05 5.00976 14.9902 0.95 10 0.95C5.00976 0.95 0.95 5.00976 0.95 10C0.95 14.9902 5.00976 19.05 10 19.05ZM10 1.85255C14.4925 1.85255 18.1475 5.50746 18.1475 10C18.1475 14.4925 14.4925 18.1475 10 18.1475C5.50746 18.1475 1.85255 14.4925 1.85255 10C1.85255 5.50746 5.50746 1.85255 10 1.85255Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77894 9.24115H7.77888C6.83389 9.24 6.06811 8.47423 6.06719 7.52923L6.06719 7.52918C6.06719 6.58393 6.83345 5.81743 7.77894 5.81743C8.72441 5.81743 9.49091 6.58391 9.49068 7.5294L7.77894 9.24115ZM7.77894 9.24115C8.72442 9.24115 9.49068 8.47467 9.49068 7.52942L7.77894 9.24115ZM8.58814 7.52918V7.5292C8.58835 7.97629 8.22605 8.3386 7.77894 8.3386C7.33208 8.3386 6.96976 7.97632 6.96974 7.52923C6.97016 7.08255 7.33227 6.72061 7.77901 6.71998L7.77894 6.66998V6.71998C8.22582 6.71998 8.58814 7.0823 8.58814 7.52918Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4031 12.5716V12.5716C10.4031 13.5171 11.1696 14.2834 12.1149 14.2834C13.0603 14.2834 13.8268 13.5171 13.8268 12.5716C13.8268 11.6262 13.0604 10.8597 12.1149 10.8597L12.1148 10.8597C11.1698 10.8608 10.4043 11.6266 10.4031 12.5716ZM10.4531 12.5716C10.4531 13.4895 11.1972 14.2334 12.1149 14.2334C13.0327 14.2334 13.7768 13.4895 13.7768 12.5716C13.7768 11.6538 13.0327 10.9097 12.1149 10.9097C11.1975 10.9108 10.4542 11.6542 10.4531 12.5716ZM12.9243 12.5716C12.9243 13.0185 12.562 13.3808 12.1149 13.3808C11.668 13.3808 11.3057 13.0185 11.3057 12.5716C11.3057 12.1248 11.668 11.7624 12.1149 11.7622L12.1149 11.7122L12.1148 11.7622C12.5617 11.7628 12.9236 12.1247 12.9243 12.5716Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2426 5.44643L13.2426 5.44649C13.3154 5.59051 13.3058 5.76245 13.2175 5.89763L13.2426 5.44643ZM13.2426 5.44643C13.1696 5.30243 13.0253 5.20823 12.8641 5.19966C12.7029 5.1911 12.5493 5.26914 12.4614 5.40462C12.4614 5.40463 12.4614 5.40464 12.4614 5.40465L6.789 14.1023L6.78899 14.1023C6.65278 14.3112 6.71167 14.5908 6.92048 14.7268C7.12923 14.863 7.409 14.8041 7.545 14.5953L13.2174 5.89767L13.2426 5.44643Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2225_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentCircle);
export default __webpack_public_path__ + "static/media/percent-circle.27fca940a70c51df29e7efdcc2b8f19c.svg";
export { ForwardRef as ReactComponent };